const InvoiceLineDetails = {
  'id': 'InvoiceLineDetails',
  'layout': {
    'rows': 2,
    'columns': 2
  },
  'fields': [
    {
      'id': 1,
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 1.5
      },
      'type': 'PAPER_CONTAINER',
      'props': {
        'fullWidth': true
      },
      'children': [
        {
          'id': 0,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Product description',
            'name': 'ProductDescription',
            'placeholder': '',
            'size': 'large',
            'disabled': true
          }
        },
        {
          'id': 1,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Customer product',
            'name': 'CustomerProduct',
            'size': 'medium',
            'placeholder': '',
            'disabled': true
          }
        },
        {
          'id': 2,
          'type': 'EXTENDED_TEXT_FIELD',
          'visible': true,
          'props': {
            'label': 'Ordered',
            'name': 'OrderedQuantity',
            'size': 'medium',
            'alignment': 'right'
          }
        },
        {
          'id': 3,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Supplied',
            'name': 'SuppliedQuantityDisplay',
            'placeholder': '',
            'size': 'medium',
            'disabled': true,
            'alignment': 'right'
          }
        },
        {
          'id': 4,
          'type': 'EXTENDED_TEXT_FIELD',
          'props': {
            'label': 'Backordered',
            'name': 'BackorderQuantityDisplay',
            'placeholder': '',
            'size': 'medium',
            'disabled': true,
            'alignment': 'right'
          }
        },
        {
          'id': 5,
          'type': 'EXTENDED_TEXT_FIELD',
          'props': {
            'label': 'Price',
            'name': 'PriceDisplay',
            'placeholder': '',
            'size': 'medium',
            'disabled': true,
            'alignment': 'right'
          }
        },
        {
          'id': 6,
          'type': 'EXTENDED_DISPLAY_FIELD',
          'props': {
            'label': 'Discount',
            'name': 'DiscountDisplay',
            'placeholder': '',
            'size': 'small',
            'disabled': true,
            'adornment': '%',
            'type': 'number',
            'alignment': 'right',
          }
        },
        {
          'id': 7,
          'type': 'TOGGLE_FIELD',
          'props': {
            'label': 'Tax included price',
            'name': 'TaxIncludedPrice',
            'defaultValue': false,
            'disabled': true,
          }
        },
        {
          'id': 8,
          'type': 'TOGGLE_FIELD',
          'props': {
            'label': 'Special price',
            'name': 'SpecialPrice',
            'defaultValue': false,
            'disabled': true
          }
        },
        {
          'id': 9,
          'type': 'TOGGLE_FIELD',
          'props': {
            'label': 'Price override',
            'name': 'PriceOverride',
            'defaultValue': false,
            'disabled': true
          }
        }
      ]
    },
    {
      'id': 1,
      'position': {
        'row': 1,
        'col': 2,
        'colspan': 1.5
      },
      'type': 'PAPER_CONTAINER',
      'props': {
        'fullWidth': true
      },
      'children': [
        {
          'id': 0,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Sales audit code',
            'name': 'SalesAuditCode',
            'placeholder': '',
            'size': 'small',
            'disabled': true
          }
        },
        {
          'id': 1,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Credit reason',
            'name': 'CreditReason',
            'placeholder': '',
            'size': 'medium',
            'required': false,
            'disabled': true
          }
        },
        {
          'id': 1,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Quoted currency',
            'name': 'QuotedCurrency',
            'placeholder': '',
            'size': 'small',
            'disabled': true
          }
        },
        {
          'id': 3,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Quoted exchange rate',
            'name': 'QuotedExhangeRateDisplay',
            'placeholder': '',
            'size': 'medium',
            'disabled': true,
            'alignment': 'right'
          }
        },
        {
          'id': 4,
          'type': 'TEXT_FIELD',
          'props': {
            'label': 'Invoice exchange rate',
            'name': 'InvoiceExhangeRateDisplay',
            'placeholder': '',
            'size': 'medium',
            'disabled': true,
            'alignment': 'right'
          }
        },
        {
          'id': 5,
          'type': 'TEXT_AREA',
          'props': {
            'name': 'Comment',
            'label': 'Invoice line comment',
            'fullWidth': true,
            'disabled': true,
            'style': {
              'height': '200px'
            }
          }
        }
      ]
    }
  ]
}
export default InvoiceLineDetails
